import moment from 'moment';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { localeData } from '../../../locales/data';
import { AlphaDetailsSummaryColumns } from '../../../shared/data/AlphaDetailsSummaryColumns';
import { addModifiers, changeArrayFormat } from '../../../shared/helpers';
import { ToolTip } from '../../ToolTip';

import { SummaryLineProps } from './types';
import './Summary.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import { getTutorialUrl } from '../../../shared/helpers/alphaMetricsTutorialLinks';

export const checkIfFailed = (title: string, checks: any) =>
  checks.filter((check: any) => check.result === 'FAIL' && check.name.toLowerCase().includes(title.toLowerCase())).length > 0
    ? 'failed'
    : '';

const getFilteredTableInfoType = (tableHeader: any, tableInfo: any, elementId: string) => {
  if (tableHeader.id === elementId) {
    if (tableInfo[elementId] !== null && tableInfo[elementId] !== undefined) {
      return changeArrayFormat([tableInfo[elementId]], [tableHeader]);
    } else {
      return '';
    }
  }

  return;
};

export const SummaryLineIntl = ({
  tableHeader,
  tableInfo,
  typeCheck,
  handlerMetrics,
  typeStage,
  showAccordionArrow,
  intl,
  isTitleHidden,
}: SummaryLineProps & InjectedIntlProps) => {
  const indexYear = tableInfo.details && tableInfo.details.schema.properties.findIndex((property: any) => property.name === 'year');
  const stageSummaryColumns = typeStage && AlphaDetailsSummaryColumns[typeStage].summary.map((value: any) => value.id);

  const summaryDate: any = {
    os: 'startDate',
    prod: 'startDate',
  };

  return (
    <div className="title sumary__metrics">
      <div className="summary-metrics-aggregate">
        <div className="summary-metrics-aggregate-title">
          {typeStage === 'os' ? (
            <FormattedMessageHelper
              tagName="span"
              id={`alphaSummary.${summaryDate[typeStage]}`}
              defaultMessage={localeData.en[`alphaSummary.${summaryDate[typeStage]}`]}
            />
          ) : (
            <FormattedMessageHelper
              tagName="span"
              id="alphaSummary.aggregateData"
              defaultMessage={localeData.en['alphaSummary.aggregateData']}
            />
          )}
        </div>
        <div className="summary-metrics-aggregate-data">
          {typeStage === 'is' && tableInfo.details
            ? tableInfo.details.records.slice(-1)[0][indexYear]
            : tableInfo[summaryDate[typeStage]]
            ? moment(tableInfo[summaryDate[typeStage]]).tz('America/New_York', true).format('L z')
            : ''}
        </div>
      </div>
      {tableHeader.map((columnElement: any, index: any) => {
        if (stageSummaryColumns && stageSummaryColumns.filter((elem: any) => elem === columnElement.id).length > 0) {
          return (
            <div className="summary-metrics-info" key={index}>
              <div className={addModifiers('summary-metrics-info', ['title'])}>
                {intl.formatMessage({ id: columnElement.title, defaultMessage: localeData.en[columnElement.title] })}
                <ToolTip
                  label={`tooltip.${columnElement.id}.label`}
                  tooltipInfo={`tooltip.${columnElement.id}.content`}
                  url={getTutorialUrl(columnElement.id)}
                />
              </div>
              <div className={addModifiers('summary-metrics-info', ['data'])}>
                {getFilteredTableInfoType(tableHeader[index], tableInfo, columnElement.id)}
              </div>
            </div>
          );
        } else {
          return;
        }
      })}
      {showAccordionArrow && (
        <div className={addModifiers('summary__metrics-arrow', typeCheck ? ['up'] : ['down'])} onClick={handlerMetrics} />
      )}
    </div>
  );
};

export const SummaryLine = injectIntl(SummaryLineIntl);
